import courseService from 'ApiService/Admin/courseService';
import batchStructureService from 'ApiService/Admin/batchService';
import Card from 'components/card';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';
import SelectClass from '../Students/AllStudents/Steps/SelectClass';
import ExternalMockResultsView from './steps/ExternalMockResultsView';
import { AuthContext } from 'contexts/AuthContext';

const Index = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [classData, setClassData] = useState({ courseId: '', batchStructureId: '', batchId: '' });
  const [disable, setDisable] = useState(true);
  const [courses, setCourses] = useState([]);
  const [batchStructures, setBatchStructures] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const { state } = useContext(AuthContext);
  const selectedBranch = state?.selectedBranch || '';

  const steps = [
    { stepNo: 1, name: 'Class Info' },
    { stepNo: 2, name: 'Mock Results' },
  ];

  useEffect(() => {
    const fetchCourses = async () => {
      setLoadingCourses(true);
      try {
        const response = await courseService.getCourseBatchInfo(selectedBranch);
        if (response.data.success) {
          setCourses(response.data.courses);
        } else {
          toast.error('Failed to fetch courses.');
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || 'Failed to fetch courses.');
      } finally {
        setLoadingCourses(false);
      }
    };
    fetchCourses();
  }, [selectedBranch]);

  const fetchBatchStructures = async (courseId) => {
    try {
      const res = await batchStructureService.getBatchStructuresByCourse(courseId);
      if (res.data.success) {
        setBatchStructures(res.data.batchStructures);
      }
    } catch {
      setBatchStructures([]);
    }
  };

  const fetchBatchesByStructure = async (structureId, branch) => {
    try {
      const res = await batchStructureService.getBatchesByBatchStructure(structureId, branch);
      return res.data.batches || [];
    } catch {
      return [];
    }
  };

  const clearData = () => {};

  const handleNext = () => {
    if (!disable) setCurrentStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setCurrentStep((prev) => (prev > 1 ? prev - 1 : prev));
  };

  const displayStep = (step) => {
    switch (step.stepNo) {
      case 1:
        return (
          <SelectClass
            setDisable={setDisable}
            setClassData={setClassData}
            classData={classData}
            courses={courses}
            batchStructures={batchStructures}
            fetchBatchStructures={fetchBatchStructures}
            fetchBatchesByStructure={fetchBatchesByStructure}
            selectedBranch={selectedBranch}
            loadingCourses={loadingCourses}
            clearData={clearData}
          />
        );
      case 2:
        return (
          <ExternalMockResultsView
            classData={classData}
            handleBack={handleBack}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="mt-3 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />
      <div
        className={`w-md:2/3 mx-auto h-full ${
          currentStep === 1 ? 'w-5/6' : 'w-6/6'
        } md:px-3 3xl:w-7/12`}
      >
        <Card extra="-mt-[280px] w-full md:-mt-[340px] md:px-[70px] h-full mx-auto pb-3">
          <div className="w-full rounded-[20px]">
            <UseContextProvider>
              {displayStep(steps[currentStep - 1])}
            </UseContextProvider>
          </div>
          <div className="flex flex-col justify-between px-3 pt-2 md:flex-row md:px-8">
            <div className="ml-auto">
              {currentStep === 1 && (
                <button
                  disabled={disable}
                  onClick={handleNext}
                  className="linear cursor-pointer rounded-xl bg-brand-900 px-16 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90"
                >
                  Next
                </button>
              )}
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Index;
